export default "__VITE_ASSET__Cq3CqsxqGE4RJZmEgM9M$g__"